import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";

// Student Detail -> Payment Override (courtesy/full) dialog (staff only).
// Extracted from StudentDetail.js (props-driven, no behavior change).
export const PaymentOverrideDialog = ({ open, onOpenChange, overrideType, noteText, onNoteTextChange, submitting, onSubmit }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent data-testid="payment-override-dialog">
      <DialogHeader>
        <DialogTitle>{overrideType === "full" ? "Grant Full Override" : "Grant Courtesy Override"}</DialogTitle>
      </DialogHeader>
      <p className="text-sm text-muted-foreground">
        {overrideType === "full"
          ? "Removes the payment hold entirely for this student until you revoke it."
          : "Allows exactly one booking or classroom enrollment through the hold — it then resumes automatically."}
      </p>
      <div className="space-y-1.5">
        <Label>Note (optional)</Label>
        <Textarea value={noteText} onChange={(e) => onNoteTextChange(e.target.value)} placeholder="e.g. Payment plan agreed with family" data-testid="payment-override-note-input" />
      </div>
      <DialogFooter>
        <Button onClick={onSubmit} disabled={submitting} data-testid="payment-override-submit-button">
          {submitting ? "Granting..." : "Grant Override"}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
